module.exports = __webpack_public_path__ + "img/broccoli.00466b27.jpg";